import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'
import axios from '@/lib/axios'

export const PROPERTY_PORTFOLIO_KEY = (orgId, period) => [
    'org',
    'property-portfolio',
    orgId,
    period
]

/**
 * One property's `category_breakdown` from the per-property portfolio
 * (GET /api/org/current/property-portfolio/?period=…). `null` when the org has no
 * categorised meter or the property has no row. Pass `enabled: false` to skip the
 * request (the Location peek is admin-only, and an uncategorised property never needs it).
 * The property league page reads the same response through `usePropertyPortfolio`.
 */
export default function usePropertyCategoryBreakdown(
    locationId,
    { period = 'last_30_days', enabled = true } = {}
) {
    const { activeOrg } = useAuth()
    const orgId = activeOrg?.id
    const query = useQuery({
        queryKey: PROPERTY_PORTFOLIO_KEY(orgId, period),
        queryFn: () =>
            axios
                .get(endPoints.PROPERTY_PORTFOLIO, { params: { period } })
                .then((response) => response.data),
        enabled: Boolean(enabled && orgId && locationId),
        staleTime: 5 * 60 * 1000
    })
    const row = query.data?.properties?.find(
        (property) => String(property.location_id) === String(locationId)
    )
    return { ...query, breakdown: row?.category_breakdown ?? null }
}
